/// <summary name='cafm.notes'>Container object for CAFM Notes code</summary>
window.notes = cafm.notes = {
    get notesSelector() { return '#' + cafm.res.consts.ElementId_NotesWrapper }, 
    listSelector: '.noteLv',
    editNoteWinHeight: 375,
    init: function (settings) {
        /// <summary>Notes initialiser</summary>
        /// <param name="settings" type="Object">Note settings</param>

        if (cafm.getCurrentModule() == cafm.enums.CAFMModuleEnum.Helpdesk)
        {
            settings.ParentEntityId = cafm.hd.workOrder.ID;
        }

        notes.settings(settings);

        // set note list view request data if there is request data
        if (settings.RequestData) {

            var getNotesReqData = {};
            notes.funcs.applyRequestData(getNotesReqData);
            notes.container().find('.cLvWrap .cLv').setCriteria(getNotesReqData);
        }
    },
    dataRetrieved: function (d) {
        /// <summary>Handler for when note list data has been retrieved</summary>
        /// <param name="d" type="Array">Array of note data</param>

        cafm.util.convertAllUTCToSessionDateTimes(d, ['CreatedDate', 'LastModifiedDate']);
    },
    editToolbar: {
        submit: function (e) {
            /// <summary>Handler for creating or updating a note</summary>
            /// <param name="e" type="Object">DOM event</param>

            var nvm = cafm.views.getActionWindowViewModel();
            notes.funcs.applyRequestData(nvm);

            var isUp = !nvm.IsNew;
            var olAction = isUp ? cafm.enums.OfflineActionType.EditNote : cafm.enums.OfflineActionType.AddNote;

            var dc = notes.settings().DataConfig;
            var st = cafm.res.str;
            var opts = {

                url: isUp ? dc.UpdatePath : dc.CreatePath,
                msg: isUp ? st.MessageNoteUpdated : st.MessageNoteAdded,
                func: isUp ? dc.OnClientUpdate : dc.OnClientCreate
            }

            var actionId = 'saveNote';
            cafm.handlers.set('dataCapture.{0}.load'.format(actionId), function (element) {

                var personLookup = element.find('#PersonID').closestField(),
                    personLookupValField = $('input[data-role="lookupValue"]', personLookup);
                $('input[data-role="lookupText"]', personLookup).prop('readonly', true);
                personLookup.data('onLookupSelected', function (args) {

                    if (args.dataItem && cafm.util.guidHasValue(args.dataItem[0].ID)) {
                        
                        personLookup.getParentViewModel().set({
                            'EmailAddress': args.dataItem[0].EmailAddress,
                            'Name': args.dataItem[0].FullName
                        });

                        element.find('#Name,#EmailAddress').prop('disabled', true);
                    }
                    else {

                        element.find('#Name,#EmailAddress').prop('disabled', false);
                    }
                });

                personLookupValField.data('lookupremove', function (args) {

                    element.find('#Name,#EmailAddress').prop('disabled', false);
                });
            });

            cafm.actions.execute({
                ref: actionId,
                url: opts.url,
                values: nvm,
                elementId: 'actionFormPlc',
                loaderSelector: '.winButtons .btn[data-key="Submit"]',
                offlineActionType: olAction,
                ParentID: cafm.actions.getObjectInContextId(),
                success: function (r) {
                    cafm.util.callFunction(opts.func, r, false);
                    notes.refreshList();
                    var msg = r.RequiredSignatureId ? cafm.res.str.MessageRiskAssessmentAdded : opts.msg;
                    notes.container().showMessage({ Type: cafm.enums.MessageType.Success, Title: msg });

                    cafm.views.closeActionWindow();

                    if (!isUp && r.RequiredSignatureId) {

                        cafm.hd.actions.sign({
                            workOrderId: r.ID,
                            signatureId: r.RequiredSignatureId
                        });
                    }
                },
                fallback: function () {
                    if (cafm.hd.workOrder) {

                        switch (olAction) {

                            case cafm.enums.OfflineActionType.AddNote:
                                var newNote = cafm.views.getActionWindowViewModel();
                                cafm.hd.workOrder.Notes = cafm.hd.workOrder.Notes || [];
                                cafm.hd.workOrder.Notes.push(newNote.Note);
                                cafm.hd.workOrder.NotesCount++; 
                                break;

                            case cafm.enums.OfflineActionType.EditNote:
                                var noteItems = cafm.notes.getWorkOrderNotes();
                                cafm.util.removeWhere(noteItems, function (n) {
                                    return n.NoteID == nvm.Note.NoteID;
                                });
                                nvm.Note.LastModifiedDate = cafm.web.funcs.getNowUTC();
                                noteItems.push(nvm.Note);
                                cafm.hd.workOrder.Notes = noteItems;
                                break;
                        }

                        // end the offline action (caches work order)
                        hdActions.helpers.endOfflineAction({
                            cacheWorkOrder: true
                        });
                        notes.refreshList();
                    }
                }
            });
        },
        cancel: function (e) {
            /// <summary>Handler for cancelling out of note creation or edits</summary>
            /// <param name="e" type="Object">DOM event</param>

            cafm.views.closeActionWindow();
        }
    },
    listToolbar: {
        add: function (e) {

            var t = $(e.currentTarget).parents('.cTb:first').data('type');
            var a = 'notes/newnote';
            if (!cafm.isOffline())
            {
                a += '/{0}'.format(cafm.actions.getObjectInContextId());
            }
            
            var tit;

            switch (t) {

                case cafm.enums.SystemNoteType.CustomerRiskAssessment:

                    a += '?systemNoteType={0}'.format(t);
                    tit = cafm.res.str.TitleAddCustomerRiskAssessment;
                    break;

                case cafm.enums.SystemNoteType.TradespersonRiskAssessment:

                    a += '?systemNoteType={0}'.format(t);
                    tit = cafm.res.str.TitleAddTradePersonRiskAssessment;
                    break;

                default:

                    tit = cafm.res.str.TitleAddNote;
                    break;
            }

            var handle;
            switch (cafm.getCurrentModule()) {

                case cafm.enums.CAFMModuleEnum.Asset:

                    handle = assetForm.performFormAction;
                    break;

                case cafm.enums.CAFMModuleEnum.Helpdesk:

                    handle = cafm.hd.performFormAction;
                    break;

                case cafm.enums.CAFMModuleEnum.Property:

                    handle = cafm.prop.handlers.form;
                    break;
            }

            handle({
                key: 'AddNote',
                action: a,
                title: tit,
                winOptions: {
                    title: tit,
                    height: cafm.notes.editNoteWinHeight
                }
            });
        },
        editOnline: function (noteParentId, noteId) {
            cafm.views.openActionWindow({
                url: cafm.url.get('Notes/EditNote/{0}/{1}', [noteParentId, noteId]),
                initialText: cafm.res.str.TextPreparingForm,
                winOptions: {
                    title: cafm.res.str.TitleEditNote,
                    height: cafm.notes.editNoteWinHeight
                }
            });
        },
        editOffline: function (noteObj) {
            var vm = {
                IsNew: false,
                Note: noteObj,
                NoteID: noteObj.NoteID, 
                ParentID: noteObj.ParentID,
            };
            var e = {
                url: cafm.url.get('Notes/EditNote'),
                initialText: cafm.res.str.TextPreparingForm,
                winOptions: {
                    title: cafm.res.str.TitleEditNote,
                    height: cafm.notes.editNoteWinHeight
                },
                onLoad: function () {
                    cafm.views.getActionForm().bindViewModel({
                        viewModel:vm
                    });
                }
            };
            cafm.views.openActionWindow(e);
        },
        edit: function (e) {
            /// <summary>Edit handler</summary>
            /// <param name="e" type="Object">The click DOM event</param>

            var editBtn = $(e.target),
                editTarget = editBtn.data('editTarget'),
                riskWrapper = editBtn.parents('.riskAssessmentsWrapper:first');

            if (riskWrapper.length || !editTarget) return;

            var lv = editBtn.getLvFromTb(),
                id = editTarget.data('id');

            if (!id) {
                notes.container().showMessage({ Type: cafm.enums.MessageType.Warning, Title: cafm.res.str.MessageNoNoteSelected });
                return;
            }
            else {
                notes.container().hideMessage(true);
            }

            var n = notes.getWorkOrderNote(id),
            noteCreatedBy = n.CreatedBy.toLowerCase(),
            username = cafm.auth.getLoginInfo().user.toLowerCase();

            if (username != noteCreatedBy) {

                notes.container().showMessage({ Type: cafm.enums.MessageType.Error, Title: cafm.res.str.MessageEditOrRemoveOthersNotesForbidden, ScrollToTop: true });
                return;
            }     

            if (cafm.isOffline()) {
                cafm.notes.listToolbar.editOffline(n);
            } else {
                cafm.notes.listToolbar.editOnline(notes.settings().ParentEntityId, id);
            }
        },
        remove: function (e) {
            /// <summary>Delete handler</summary>
            /// <param name="e" type="Object">The click DOM event</param>

            var lvEl = $(e.target),
                s = notes.settings(),
                parentId = s.ParentEntityId && s.ParentEntityId != cafm.guid.empty ? s.ParentEntityId : cafm.hd.workOrder.get('ID'),
                selIds = lvEl.getListSelectedParentChildArray({ parentId: parentId, field: 'NoteID' });

            if (!selIds) {
                notes.container().showMessage({ Type: cafm.enums.MessageType.Warning, Title: cafm.res.str.MessageNoNoteSelected });
                return;
            }

            selIds.forEach(function (idsItem) {

                notes.funcs.applyRequestData(idsItem);
            });

            cafm.actions.execute({
                url: s.DataConfig.DeletePath,
                description: cafm.res.str.TextDeleteNote,
                values: selIds,
                elementId: cafm.res.consts.ElementId_NotesWrapper,
                loaderSelector: notes.notesSelector,
                preventValidate: true,
                statusCodeFuncs: {
                    200: function (r) {

                        cafm.util.callFunction(s.DataConfig.OnClientDelete, r);
                        notes.refreshList();
                        notes.container().showMessage({ Type: cafm.enums.MessageType.Success, Title: cafm.res.str.MessageItemsDeleted });
                    }
                }
            });
        }
    },
    funcs: {
        applyRequestData: function (o) {

            let s = notes.settings();
            if (s && s.RequestData && isStr(s.RequestDataName)) {

                o[s.RequestDataName] = s.RequestData;
            }
        }
    },
    handlers: {
        noteTypeChanged: function (e) {

            var select = $(e.currentTarget),
                kdl = select.getKendoDropDownList(),
                viewModel = select.getParentViewModel(),
                selected = cafm.util.find(kdl.dataSource.data(), function (i) { return i.value == select.val() });

            if (selected) {
                if (cafm.util.hasStringVal(selected.customValue1)) {
                    var noteContent = selected.customValue1;
                    if (viewModel.Note.Note) {
                        noteContent += cafm.getClientSettings().newLine;
                        noteContent += viewModel.Note.Note;
                    }
                    viewModel.set('Note.Note', noteContent);
                }
                viewModel.Note.NoteTypeDescription = selected.text;
            }
        }
    },
    refreshList: function () {

        var c = notes.container(),
            key = c.data('key'),
            isRisk = key == cafm.res.consts.DataKey_HelpdeskCustomerRiskAssessments || key == cafm.res.consts.DataKey_HelpdeskTradePersonRiskAssessments;

        cafm.util.refreshList({
            list: c.find('.cLvWrap'),
            key: key,
            callback: isRisk ? function() {

                var custRiskList = $('.riskAssessmentsWrapper[data-key="{0}"] .cLv'.format(cafm.res.consts.DataKey_HelpdeskCustomerRiskAssessments)),
                    custRiskCount = custRiskList.length ? custRiskList.getListItemCount() : cafm.hd.workOrder.CustomerRiskAssessmentsCount,
                    tradeRiskList = $('.riskAssessmentsWrapper[data-key="{0}"] .cLv'.format(cafm.res.consts.DataKey_HelpdeskTradePersonRiskAssessments)),
                    tradeRiskCount = tradeRiskList.length ? tradeRiskList.getListItemCount() : cafm.hd.workOrder.TradePersonRiskAssessmentsCount,
                    checkCount = cafm.hd.workOrder.RiskAssessmentChecklistCount,
                    totalCount = 0;

                if (custRiskCount > 0) {

                    totalCount += custRiskCount;
                }

                if (tradeRiskCount > 0) {

                    totalCount += tradeRiskCount;
                }

                if (checkCount > 0) {

                    totalCount += checkCount;
                }
                
                cafm.tab.displayItemCount($('#formWidget > ul > [data-key="{0}"]'.format(cafm.res.consts.DataKey_HelpdeskRiskAssessments)), totalCount);
            } : null    
        });
    },
    container: function () {

        if (isMobile) {
            return cafm.views.getMainForm().find('.cafmPb:first > .k-state-active').find(notes.notesSelector);
        }
        else {
            return cafm.views.getMainForm().find('.cafmTabs:first > .k-content.k-state-active').find(notes.notesSelector);
        }
    },
    settings: function (settings) {

        if (!settings) {
            return notes.container().data('settings');
        }
        else {
            notes.container().data('settings', settings);
        }
    },
    getWorkOrderNotes: function () {

        return cafm.hd.getWorkOrderChildList('Notes');
    },
    getWorkOrderNote: function (noteId) {
        return cafm.util.findByFieldValue(notes.getWorkOrderNotes(), 'NoteID', noteId);
    },
    getWorkOrderCustomerRiskAssessments: function () {

        return cafm.hd.getWorkOrderChildList('CustomerRiskAssessments');
    },
    getWorkOrderTradePersonRiskAssessments: function () {

        return cafm.hd.getWorkOrderChildList('TradePersonRiskAssessments');
    },
    enablePermissibleFeatures: function (p) {

        var nlv = $('#noteLv'),
            lh = nlv.find('.cLvHead');

        if (isMobile && (p.add || p.remove)) {

            lh.show();
        }
        if (p.add) {
            $('[data-key="Add"]', lh).show();
        }
        if (!p.remove) {

            nlv.disableListItemRemoving();
        }
        if (!p.edit) {

            nlv.disableListItemEditing();
        }

        notes.permissions = p;
    },
    enablePermissibleFeaturesOffline: function (p) {
        var p = {
            view: hdActions.offlineSecurity.isAllowed(cafm.enums.LogWorkOrderAction.ViewNotes),
            add: hdActions.offlineSecurity.isAllowed(cafm.enums.LogWorkOrderAction.AddNote),
            edit: hdActions.offlineSecurity.isAllowed(cafm.enums.LogWorkOrderAction.EditNote),
            remove: false 
        };
        cafm.notes.enablePermissibleFeatures(p);
    },
    enableCustomerRiskPermissibleFeatures: function (p) {
        
        var nlv = $('#customerRiskLv'),
            lh = nlv.find('.cLvHead');

        if (p.add || p.remove) {

            lh.show();
        }
        if (p.add) {

            $('[data-key="Add"]', lh).show();
        }
        if (!p.remove) {

            nlv.disableListItemRemoving();
        }
        if (!p.edit) {

            nlv.disableListItemEditing();
        }

        notes.permissions = p;
    },
    enableTradePersonRiskPermissibleFeatures: function (p) {
                
        var nlv = $('#tradesPersonRiskLv'),
            lh = nlv.find('.cLvHead');

        if (p.add || p.remove) {

            lh.show();
        }
        if (p.add) {

            $('[data-key="Add"]', lh).show();
        }
        if (!p.remove) {

            nlv.disableListItemRemoving();
        }
        if (!p.edit) {

            nlv.disableListItemEditing();
        }
        
        notes.permissions = p;
    }
}